export const SET_AUTHENTIFICATION = "SET_AUTHENTIFICATION"
export const PARSE_MESSAGE = "PARSE_MESSAGE"
export const PARSE_ERROR = "PARSE_ERROR"
export const RESET_ERROR = "RESET_ERROR"
export const SET_NEWS = "SET_NEWS";